<template>
  <div>
    <div class="list" v-for="(item, index) in list" :key="item.id" @click="bagWorkList(index)">
      <div class="list-content">
        <div class="date">{{ item.dateStart | trimT }}</div>
        <div class="name">{{ item.name }}</div>
        <div class="num">{{ item.itemNum }}个子作业</div>
        <div :class="['status', item.status === '0' ? 'col-329cf3' : item.status === '1' ? 'col-1DC060' : 'col-999']">
          {{ item.status === '0' ? '未开始' : item.status === '1' ? '进行中' : '已结束' }}
        </div>
        <div class="clazz">{{ item.clazzName }}</div>
        <div class="btn-column">
          <div class="btn btn-1" @click.stop="exportExcel(item.id)">导</div>
          <div class="btn btn-2" @click.stop="setWork(item)">修</div>
          <div class="btn btn-3" @click.stop="delWork(index)">删</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BagList',
  props: ['list'],
  methods: {
    exportExcel(itemId) {
      this.$emit('exportExcel', itemId)
    },
    setWork(item) {
      this.$emit('setWork', item)
    },
    delWork(index) {
      this.$emit('delWork', index)
    },
    bagWorkList(index) {
      this.$emit('bagWorkList', index)
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  padding: 0 28px;
  cursor: pointer;
  transition: .5s;

  &:hover {
    box-shadow: 0 6px 20px 0 rgba(0, 0, 0, .08);
  }

  .list-content {
    @include flex;
    height: 80px;
    border-bottom: 1px solid #F1F1F1;
    font-size: 17px;
    text-align: center;

    .date {
      flex-shrink: 0;
      width: 122px;
      color: #999;
    }

    .name {
      flex-grow: 1;
      font-weight: bold;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .num {
      flex-shrink: 0;
      width: 146px;
    }

    .status {
      flex-shrink: 0;
      width: 100px;
    }

    .clazz {
      flex-shrink: 0;
      width: 146px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .btn-column {
      flex-shrink: 0;
      @include flex;
      width: 136px;

      .btn {
        width: 30px;
        height: 30px;
        line-height: 30px;
        border: 1px solid #1DC060;
        border-radius: 4px;
        margin-right: 8px;
        @include font(15px, #1DC060, center);
        cursor: pointer;

        &:last-child {
          margin-right: 0;
        }
      }

      .btn-1:hover {
        color: #FFFFFF;
        background-color: #1DC060;
      }

      .btn-2 {
        color: #309AF2;
        border-color: #309AF2;

        &:hover {
          color: #FFFFFF;
          background-color: #309AF2;
        }
      }

      .btn-3 {
        color: #FF3C30;
        border-color: #FF3C30;

        &:hover {
          color: #FFFFFF;
          background-color: #FF3C30;
        }
      }
    }
  }
}
</style>
